<template>
  <div class="case-collect-pane" v-loading="loading">
    <div class="collect-pane-title">
      <span>类案收藏</span>
      <span class="total-count" v-if="total">（{{ total }}）</span>
      <slot name="header-close-btn"></slot>
    </div>
    <div class="collect-pane-container">
      <div class="folder-ul">
        <div class="empty-content" v-show="!list.length">
          <img class="empty-img" :src="emptyImg" />
          <div class="empty-text">暂无收藏夹</div>
        </div>
        <div class="folder-li" v-for="(item, index) in list" :key="index" @click="item.showExpand = !item.showExpand">
          <div class="folder-li-conetnt">
            <img class="folder-img" :src="folderImg" />
            <span>
              <span>{{ item.label }}</span>
              <span :style="{ fontSize: '12px' }">（{{item.children.length}}）</span>
            </span>
            <el-tooltip class="item" effect="dark" content="删除收藏夹" placement="left">
              <div class="folder-del-btn" @click.stop="delFolderHandle(item)">
                <i class="el-icon-close"></i>
              </div>
            </el-tooltip>
          </div>

          <div class="case-ul" v-show="item.showExpand">
            <div class="empty-content" v-show="!item.children.length">
              <img class="empty-img" :src="emptyImg" />
              <div class="empty-text">暂无收藏案例</div>
            </div>
            <div class="case-li" v-for="caseItem in item.children" :key="caseItem.caseid" @click="routeToDetail(caseItem)">
              <div class="case-li-title">
                <div class="case-li-type" v-if="caseItem.full_type">
                  <span>{{ caseItem.full_type }}</span>
                </div>
                <span>{{ caseItem.title }}</span>
              </div>
              <el-tooltip class="item" effect="dark" content="取消收藏" placement="left">
                <div class="case-li-del-btn" @click.stop="cancelCollectHandle(item, caseItem)">
                  <i class="el-icon-close"></i>
                </div>
              </el-tooltip>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import folderImg from '@/assets/收藏夹.png';
import emptyImg from '@/assets/暂无数据.png';
import { services } from '@/service';
import { projectInfoConfig } from '@/constant';

export default {
  data() {
    return {
      loading: false,
      list: [],
      folderImg,
      emptyImg
    };
  },
  computed: {
    total() {
      let count = 0;
      this.list.forEach(item => {
        count += item.children.length;
      })
      return count;
    }
  },
  mounted() {
    services.logger.handleLog({ operateName: '查看类案收藏夹' });
    this.initListHandle();
  },
  methods: {
    async initListHandle() {
      try {
        this.loading = true;
        const { data } = await this.httpPost('/nlp/case/collect/list', {});
        const list = [];
        Object.keys(data).forEach(key => {
          if (!key) {
            return;
          }
          const children = data[key].filter(item => item.caseid);
          // if (children.length) {
            list.push({ label: key, children , showExpand: false });
          // }
        })
        this.list = list;
      } catch (err) {
        this.$message.error(err.message);
      } finally {
        this.loading = false;
      }
    },
    routeToDetail(item) {
      const { href } = this.$router.resolve({
        path: '/case/result/detail',
        query: {
            id: item.caseid,
            type: item.type,
        }
      });
      this.$emit('routeCase');
      if (projectInfoConfig.crossOriginIFrame) {
          window.location.href = href;
      } else {
          window.open(href, '_blank');
      }
    },
    async delFolderHandle(item) {
      await this.$confirm(`是否确认删除【${item.label}】收藏夹，删除后会自动取消收藏该收藏夹以内的案例。`);
      try {
        this.list = this.list.filter(o => o !== item);
        await this.httpPost('/nlp/case/collect/list/delete', { path: item.label });
        this.$message.success('收藏夹删除成功');
        this.$emit('refresList');
      } catch (err) {
        this.$message.error(err.message);
      }
    },
    async cancelCollectHandle(folder, item) {
      await this.$confirm('是否确认取消收藏');
      try {
        folder.children = folder.children.filter(v => v.caseid !== item.caseid);
        await this.httpPost('/nlp/case/collect', {
          _op_type: 'delete',
          caseid: item.caseid,
          type: item.type,
          title: item.title,
          path: folder.label
        });
        this.$message.success('已取消收藏')
        this.$emit('refresList');
      } catch (err) {
        this.$message.error(err.message);
      }
    }
  },
};
</script>

<style lang="less" scoped>
.case-collect-pane {
  min-height: 200px;
  .collect-pane-title {
    position: relative;
    height: 66px;
    line-height: 66px;
    font-size: 18px;
    font-weight: bold;
    color: @wordColor1;
    padding-left: 22px;

    span{
      font-weight: inherit;
    }

    .total-count {
      color: #9599A5;
      font-size: 14px;
      font-weight: normal;
    }

    &.back {
      cursor: pointer;
    }
  }

  .collect-pane-container {
    padding: 0 20px;

    .empty-content {
      margin-top: 40px;
      text-align: center;
      .empty-img {
        width: 100px;
      }
      .empty-text {
        font-size: 14px;
        color: #999;
        margin-top: 10px;
      }
    }
  }
  .case-ul {
    .case-li {
      display: flex;
      align-items: flex-start;
      padding: 14px 10px;
      cursor: pointer;
      background-color: #F7F7F7;

      &:hover {
        background-color: #E6E6E6;
      }

      .case-li-type {
        display: inline-block;
        flex: 80px 0 0;
        height: 24px;
        line-height: 24px;
        color: #fff;
        font-size: 12px;
        background-color: #2C7DDC;
        border-radius: 2px;
        text-align: center;
        padding: 0 10px;
        margin-right: 6px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      
      .case-li-title {
        flex: 1;
        width: 0;
        display: flex;
        align-items: flex-start;
        font-size: 16px;
        color: #222222;
        line-height: 25px;
      }
      .case-li-del-btn {
        width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        cursor: pointer;
        margin-left: 10px;
      }
    }
  }
  .folder-ul {
    margin-top: 10px;
    .folder-li {
      .folder-li-conetnt {
        position: relative;
        box-sizing: border-box;
        height: 60px;
        line-height: 60px;
        font-size: 16px;
        color: #222222;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        cursor: pointer;
        padding: 0 10px;
        padding-right: 30px;
        
        .folder-img {
          position: relative;
          top: 5px;
          height: 22px;
          margin-right: 2px;
        }
  
        .folder-del-btn {
          position: absolute;
          right: 10px;
          top: 0px;
          visibility: hidden;
        }
  
        &:hover {
          .folder-del-btn {
            visibility: visible;
          }
        }
  
        &.is-active, &:hover {
          background-color: #E6E6E6;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/cases/components/caseCollectPane.vue